import * as React from "react";
import styled from "styled-components";
import { select } from "@hubper/theme";

type BaseProps = {
  space: number;
  justifyContent?: Props["justifyContent"];
};

const Base = styled.div<BaseProps>`
  display: flex;
  align-items: flex-start;
  justify-content: ${p => p.justifyContent};
  &:not(:last-child) {
    margin-bottom: ${p => select.space(p.space)};
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  children: any;
  space?: any;
  justifyContent?: React.CSSProperties["justifyContent"];
};

function FormRow(
  { style, className, children, space = 5, justifyContent }: Props,
  ref: any
) {
  return (
    <Base
      ref={ref}
      style={style}
      className={className}
      space={space}
      justifyContent={justifyContent}
    >
      {children}
    </Base>
  );
}

export default React.forwardRef(FormRow);
